/**
 * Logger silencioso em produção — evita expor erros internos no console do browser.
 * Em desenvolvimento, passa diretamente para console.
 */
const isProd = process.env.NODE_ENV === 'production';

const logger = {
  error: isProd ? () => {} : (...a) => console.error(...a),  // eslint-disable-line no-console
  warn:  isProd ? () => {} : (...a) => console.warn(...a),   // eslint-disable-line no-console
  log:   isProd ? () => {} : (...a) => console.log(...a),    // eslint-disable-line no-console
};

export default logger;
